import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SideNavLayout from "../Sidenav/SideNavLayout";
import UserModal from "./modals/usermodal";

import EditIcon from "@mui/icons-material/Edit";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import PersonAddRoundedIcon from "@mui/icons-material/PersonAddRounded";

import CircularProgress from "@mui/material/CircularProgress";
import api from "../api/api";

const Generalusers = () => {
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [users, setUsers] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");

  const handleEdit = (user) => {
    setEditData(user);
    setIsModalOpen(true);
  };

  const getAllUsers = async () => {
    try {
      setLoader(true);
      const response = await api.get("/v1/admin-user/get");

      if (response.status === 200) {
        setUsers(response?.data || []);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  const handleSave = async (data, editDataRef) => {
    try {
      setLoader(true);

      if (editDataRef) {
        const id = editDataRef.id;
        const response = await api.put(`/v1/admin-user/${id}`, data);

        if (response.status === 200) {
          getAllUsers();
        }
      } else {
        const payload = {
          name: data.name,
          mobile_number: data.mobile_number,
          company_name: data.company_name,
          email: data.email,
        };

        const response = await api.post("/v1/admin-user/create", payload);

        if (response.status === 200 || response.status === 201) {
          getAllUsers();
        }
      }
    } catch (error) {
      console.error("Save Error:", error);
    } finally {
      setLoader(false);
      setIsModalOpen(false);
      setEditData(null);
    }
  };

  const filteredUsers = users.filter((u) => {
    const s = searchText.toLowerCase();
    return (
      u.name?.toLowerCase().includes(s) ||
      u.company_name?.toLowerCase().includes(s) ||
      u.email?.toLowerCase().includes(s) ||
      u.mobile_number?.toLowerCase().includes(s)
    );
  });

  return (
    <SideNavLayout>
      {loader && (
        <div className="fixed inset-0 bg-white bg-opacity-70 flex justify-center items-center z-[9999]">
          <CircularProgress size={60} />
        </div>
      )}

      <div className="p-6">

        {/* Top Buttons */}
        <div className="flex justify-center gap-2 items-center mb-6">
          <button
            onClick={() => navigate("/dashboard")}
            className="bg-[#145388] flex items-center gap-1 text-white px-3 py-1 rounded-md text-sm"
          >
            <HomeRoundedIcon style={{ width: "20px" }} /> Home
          </button>

          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-[#145388] flex items-center gap-1 text-white px-3 py-1 rounded-md text-sm"
          >
            <PersonAddRoundedIcon style={{ width: "20px" }} /> Add User
          </button>
        </div>

        {/* Search Bar */}
        <div className="flex justify-end mb-3">
          <input
            type="text"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="border border-gray-300 p-2 rounded-2xl text-sm pl-4 w-64 focus:outline-none"
          />
        </div>

      {/* TABLE */}
<div className="bg-white w-full mx-auto rounded-lg">
  <div className="overflow-x-auto border rounded-lg p-0">
    <table className="w-full table-auto border-collapse text-left">
      
      {/* HEADER */}
      <thead className="bg-[#eee] text-gray-700">
        <tr className="font-semibold">
          <th className="p-3">Person Name</th>
          <th className="p-3">Company Name</th>
          <th className="p-3">Email</th>
          <th className="p-3">Mobile</th>
          <th className="p-3">Status</th>
          <th className="p-3">Actions</th>
        </tr>
      </thead>

      {/* BODY */}
      <tbody>
        {filteredUsers.length === 0 ? (
          <tr>
            <td colSpan="6" className="p-4 text-center text-gray-500">
              No users found.
            </td>
          </tr>
        ) : (
          filteredUsers.map((u) => (
            <tr key={u.email} className="border-t">
              <td className="p-3">{u.name}</td>
              <td className="p-3">{u.company_name}</td>
              <td className="p-3">{u.email}</td>
              <td className="p-3">{u.mobile_number}</td>

              <td
                className={`p-3 font-medium ${
                  u.status === "A" ? "text-green-700" : "text-red-600"
                }`}
              >
                {u.status === "A" ? "Active" : "Inactive"}
              </td>

              <td className="p-3">
                <div className="flex gap-3 items-center">
                  <EditIcon
                    className="text-blue-600 cursor-pointer"
                    onClick={() => handleEdit(u)}
                  />
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>

    </table>
  </div>
</div>


      </div>

      {isModalOpen && (
        <UserModal
          editData={editData}
          onSave={handleSave}
          onClose={() => {
            setEditData(null);
            setIsModalOpen(false);
          }}
        />
      )}
    </SideNavLayout>
  );
};

export default Generalusers;
